module.exports = __webpack_public_path__ + "img/36d2a31.png";